import { RequestQuery } from 'common';

import type { QuotesOverviewQueryParams } from './types';

/** Prefix for refetch/invalidate; matches all quotes overview queries. */
export const getQuotesOverviewQueryKeyPrefix = () =>
  ['quotes', 'quotesOverview'] as const;

export type QuotesOverviewQueryKeyPrefixType = ReturnType<
  typeof getQuotesOverviewQueryKeyPrefix
>;

export type QuotesOverviewQueryKeyType = [
  ...QuotesOverviewQueryKeyPrefixType,
  RequestQuery<QuotesOverviewQueryParams> | undefined,
];

export const getQuotesOverviewQueryKey = (
  query?: RequestQuery<QuotesOverviewQueryParams>,
): QuotesOverviewQueryKeyType => [...getQuotesOverviewQueryKeyPrefix(), query];
